import { TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import styled from "styled-components";

export const TableCellStyle = styled(TableCell)`
    && {
        width: 250px;
        overflow: hidden;
        color: var(--gray);
        border-bottom: 1px solid var(--light-sky);
        border: none;
        font-weight: bold;
    }
`;

export const TableContainerStyled = styled(TableContainer)`
    && {
        width: calc(99% - 1rem);
        margin: 1rem;
        border-radius: 1rem;
        box-shadow: 0 10px 15px 0 rgba(--shadow);
        background: var(--white);
    }
`;
export const TableHeadStyled = styled(TableHead)`
    && {
        border-bottom: 1px solid var(--light-gray);
        th {
            color: var(--dark-gray);
            font-weight: bold;
            text-align: center;
        }
    }
`;
export const TableRowStyled = styled(TableRow)`
    && {
        &:nth-child(odd) {
            background: var(--light-gray);
        }
        td {
            text-align: center;
        }
    }
`;
export const ProgressStyled = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;
